/**
 * The Health heart: the AI Studio artwork (body + ECG-like signal line) in a
 * `-2 -3 44 44` viewBox. Shared by `HealthHeart.tsx` (native, Reanimated on
 * the UI thread), `HealthHeart.web.tsx` (CSS keyframes in global.css under
 * `.tabbio-health-heart`) and the editor dock's Heart Agent launcher
 * (`ActionDockHealthButton(.web).tsx`), so every surface draws and times the
 * same mark.
 *
 * The paths, points and samplers live in `@tabbio/utils/cv-health-view`,
 * shared with the public CV Health pages; this module keeps the app's import
 * path and public names stable.
 *
 *   working   ink colour; the body breathes 0.65 -> 1 -> 0.65 over 2.4 s and
 *             the signal draws itself over the first 1.4 s of each cycle,
 *             then holds until the next beat
 *   resting   text colour, static, signal fully drawn
 *   launcher  solid body in the toolbar icon colour under a coloured signal
 *             line (score band) that sways along 80 resampled points
 *
 * Pure module: no React, no platform code.
 */
export {
  HEALTH_HEART_BOX,
  HEALTH_HEART_DEFAULT_SIZE,
  HEALTH_HEART_LINE_STROKE_WIDTH,
  HEALTH_HEART_MOTION,
  HEALTH_HEART_PATH,
  HEALTH_HEART_SIGNAL_BAND,
  HEALTH_HEART_SIGNAL_PATH_LENGTH,
  HEALTH_HEART_SIGNAL_POINTS,
  HEALTH_HEART_VIEWBOX,
  HEALTH_HEART_WAVE,
  HEALTH_SIGNAL_DRAW_END,
  HEALTH_SIGNAL_LENGTH,
  HEALTH_SIGNAL_PATH,
  HEALTH_SIGNAL_STROKE_WIDTH,
  getHeartSignalColor,
  heartSignalPath,
  polylineLength,
  sampleHeartBreathe,
  sampleSignalOffset,
} from '@tabbio/utils/cv-health-view';
export type { HealthHeartSignalBand } from '@tabbio/utils/cv-health-view';
